"use strict";
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotSignIn = void 0;
const core_http_1 = require("@azure/core-http");
const Mappers = require("../models/botSignInMappers");
const Parameters = require("../models/parameters");
/** Class representing a BotSignIn. */
class BotSignIn {
    /**
     * Create a BotSignIn.
     * @param {TokenApiClientContext} client Reference to the service client.
     */
    constructor(client) {
        this.client = client;
    }
    getSignInUrl(state, options, callback) {
        return this.client.sendOperationRequest({
            state,
            options
        }, getSignInUrlOperationSpec, callback);
    }
    getSignInResource(state, options, callback) {
        return this.client.sendOperationRequest({
            state,
            options
        }, getSignInResourceOperationSpec, callback);
    }
}
exports.BotSignIn = BotSignIn;
// Operation Specifications
const serializer = new core_http_1.Serializer(Mappers);
const getSignInUrlOperationSpec = {
    httpMethod: "GET",
    path: "api/botsignin/GetSignInUrl",
    queryParameters: [
        Parameters.state,
        Parameters.codeChallenge,
        Parameters.emulatorUrl,
        Parameters.finalRedirect
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer
};
const getSignInResourceOperationSpec = {
    httpMethod: "GET",
    path: "api/botsignin/GetSignInResource",
    queryParameters: [
        Parameters.state,
        Parameters.codeChallenge,
        Parameters.emulatorUrl,
        Parameters.finalRedirect
    ],
    responses: {
        200: {
            bodyMapper: Mappers.SignInUrlResponse
        },
        default: {}
    },
    serializer
};
//# sourceMappingURL=botSignIn.js.map